import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import {
  useRecoilCallback,
  useRecoilValue,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE,
  useSetRecoilState,
} from "recoil";
import AutocompleteSkeleton from "src/shared/components/skeletons/AutocompleteSkeleton";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";
import AutocompletePrevision from "./components/autocompletes/AutocompletePrevision";
import AutocompleteProfessionals from "./components/autocompletes/AutocompleteProfessionals";
import AutocompleteSpecialities from "./components/autocompletes/AutocompleteSpecialities";
import AutocompleteSucursales from "./components/autocompletes/AutocompleteSucursales";
import {
  covenantsFetchState,
  covenantsState,
  professionalsBySpecialityState,
  professionalsState,
  specialitiesFetchState,
  specialitiesState,
  sucursalesFetchState,
  sucursalesState,
} from "./components/autocompletes/state/atoms";
import {
  filterSearchSelectedState,
  isChangeFormSearchState,
} from "./state/atoms";
import AutocompleteModalidad from "./components/autocompletes/AutocompleteModalidad";
import { InputRut } from "src/shared/components/forms/InputRut";
import { userState } from "src/store/user/userState";

const FormSearch = ({
  size = "small",
  md = 12,
  styles = {},
  buttonSearch = null,
}) => {
  const { catchErrorApi } = useCatchErrorApi();
  const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);
  const filterSearchSelected = useRecoilValue(filterSearchSelectedState);
  const setCovenants = useSetRecoilState(covenantsState);
  const setProfessionals = useSetRecoilState(professionalsState);
  const setSpecialities = useSetRecoilState(specialitiesState);
  const setSucursales = useSetRecoilState(sucursalesState);
  const [loading, setLoading] = useState(false);
  const user = useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(userState);

  const loadData = useRecoilCallback(
    ({ snapshot }) =>
      async () => {
        const release = snapshot.retain();
        setLoading(true);
        console.log("load data form search");
        try {
          const sucursalesFetch = snapshot.getPromise(sucursalesFetchState);
          const specialitiesFetch = snapshot.getPromise(
            specialitiesFetchState(filterSearchSelected.modalidadSelected.tipo),
          );
          const professionalsFetch = snapshot.getPromise(
            professionalsBySpecialityState({
              specialityName: filterSearchSelected.specialitySelected.value,
              modalidad: filterSearchSelected.modalidadSelected.tipo,
            }),
          );
          const covenantsFetch = snapshot.getPromise(covenantsFetchState);
          const responses = await Promise.all([
            sucursalesFetch,
            covenantsFetch,
            specialitiesFetch,
            professionalsFetch,
          ]);
          console.log(responses, "load data form search - responses");
          setSucursales(responses[0]);
          setCovenants(responses[1]);
          setSpecialities(responses[2]);
          setProfessionals(responses[3]);
        } catch (error) {
          catchErrorApi(error);
        } finally {
          setLoading(false);
          release();
        }
      },
    [],
  );

  useEffect(() => {
    loadData();

    return () => {
      loadData();
    };
  }, [loadData]);

  useEffect(() => {
    return () => {
      setIsChangeFormSearch(false);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={"12px"}>
      {!user.isAuthenticated && (
        <Grid item md={md} xs={12} bottom>
          <InputRut styles={{ ...styles }} />
        </Grid>
      )}
      <Grid item md={md} xs={12} bottom>
        {loading ? (
          <AutocompleteSkeleton />
        ) : (
          <AutocompleteSucursales size={size} styles={{ ...styles }} />
        )}
      </Grid>

      {/* <Grid item md={md} xs={12} bottom>
        {loading ? (
          <AutocompleteSkeleton />
        ) : (
          <AutocompleteModalidad size={size} styles={{ ...styles }} />
        )}
      </Grid> */}

      <Grid item md={md} xs={12} bottom>
        {loading ? (
          <AutocompleteSkeleton />
        ) : (
          <AutocompleteSpecialities size={size} styles={{ ...styles }} />
        )}
      </Grid>

      <Grid item md={md} xs={12}>
        {loading ? (
          <AutocompleteSkeleton />
        ) : (
          <AutocompleteProfessionals size={size} styles={{ ...styles }} />
        )}
      </Grid>

      <Grid item md={md} xs={12}>
        {loading ? (
          <AutocompleteSkeleton />
        ) : (
          <AutocompletePrevision size={size} styles={{ ...styles }} />
        )}
      </Grid>
      {buttonSearch && (
        <Grid
          display={"flex"}
          justifyContent="center"
          alignItems={"center"}
          item
          md={md}
          xs={12}
        >
          {buttonSearch}
        </Grid>
      )}
    </Grid>
  );
};

export default FormSearch;
